import {
  Context,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

import { Path } from '~/routes/constants';

export const enum UserMode {
  MAUD = 'MAUD',
  ADMIN = 'Admin',
  OPS = 'Ops',
  UNKNOWN = 'Unknown',
}

export const UserModeRoutes: Record<UserMode, string> = {
  [UserMode.MAUD]: Path.MAUD,
  [UserMode.ADMIN]: Path.ADMIN,
  [UserMode.OPS]: Path.OPS,
  [UserMode.UNKNOWN]: Path.PORTAL,
};

export type TModeContext = {
  mode: UserMode;
  setMode: Dispatch<SetStateAction<UserMode>>;
};

export const ModeContext: Context<TModeContext> = createContext<TModeContext>({
  mode: UserMode.UNKNOWN,
  setMode: (_value: UserMode) => {},
});

export const ModeContextProvider = ({ children }: PropsWithChildren) => {
  const [mode, setMode] = useState<UserMode>(UserMode.UNKNOWN);

  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useModeContext = (): TModeContext => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error(
      'useModeContext must be used within a ModeContextProvider.',
    );
  }
  return context;
};
